/**
 * Generate the GSTR-3B working paper for a period, and fetch where to download
 * it (finding A3, 2026-09-28).
 *
 * Its own function, not inline in `Gstr3b.tsx`, because the wiring is the risk:
 * the route test on the service passes whatever period a button posts to, and
 * a download that asks for the wrong artifact still answers with a URL. This is
 * what `tests/working-paper.test.ts` holds — **the same period both times, and
 * the artifact the generate call just returned**.
 */

import { type GeneratedArtifact, periods } from './api'
import type { FetchedFile } from './files'

export interface GeneratedPaper {
  artifact: GeneratedArtifact
  /** The paper's bytes, from ProGST itself, to save straight away. */
  file: FetchedFile
}

export async function generateWorkingPaper(periodId: string): Promise<GeneratedPaper> {
  const artifact = (await periods.generate3bWorking(periodId)).data
  const file = await periods.artifactFile(periodId, artifact.id)
  return { artifact, file }
}
